module.exports = __webpack_public_path__ + "static/media/resource_img.25c53713.jpg";